import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import './SEOContent.scss';

const SEOContent = ({ title, subtitle, body }) => (
  <article className="seo-wrapper">
    {title && <h2>{trans(title)}</h2>}
    {subtitle && <h3>{trans(subtitle)}</h3>}
    <div
      dangerouslySetInnerHTML={{
        __html: trans(body)
      }}
    />
  </article>
);

SEOContent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.string
};

SEOContent.defaultProps = {
  title: '',
  subtitle: '',
  body: ''
};

export default SEOContent;
